import React, { useState } from "react";
import { Button, TextField, MenuItem, Select, FormControl, InputLabel, Typography, Box, Checkbox, FormControlLabel } from "@mui/material";

// Main Component
const EventGames = () => {
    const [eventType, setEventType] = useState("USCF"); // Default to USCF
    const [eventId, setEventId] = useState("");

    const handleFindEventGames = () => {
        if (eventId) {
            const url = `/games/gamesbyeventid?idtype=${eventType}&id=${eventId}`;
            window.open(url, "_blank");
        } else {
            alert("Please enter an Event ID.");
        }
    };

    const handleEventIdChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) { // Allow only digits
            setEventId(value);
        }
    };

    return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                <FormControl sx={{ minWidth: 120 }}>
                    <InputLabel id="event-type-label">Event Type</InputLabel>
                    <Select
                        labelId="event-type-label"
                        id="eventType"
                        value={eventType}
                        onChange={(e) => setEventType(e.target.value)}
                    >
                        <MenuItem value="USCF">USCF</MenuItem>
                        <MenuItem value="FIDE">FIDE</MenuItem>
                    </Select>
                </FormControl>

                <TextField
                    id="eventId"
                    label="Enter Event ID"
                    variant="outlined"
                    value={eventId}
                    onChange={handleEventIdChange}
                    placeholder="e.g. 1234567"
                    sx={{ width: 200 }} // Smaller size for the input box
                />

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleFindEventGames}
                    sx={{ whiteSpace: "nowrap" }}
                >
                    Search Event Games
                </Button>
            </Box>
    );
};

export default EventGames;
